<template>
	<div class="d-flex flex-column" style="width: 100px; height: 100%; gap: 2px">
		<div v-if="getWorked" class="d-flex position-relative">
			<div class="d-flex w-100 justify-content-end">
				<button class="btn-transparent text-color-rhapsody-in-blue" v-b-tooltip.hover.left.html="`${labelStatus}`">
					<div :class="`status-${labelStatusColor}`" style="font-size: 0.7rem"></div>
				</button>
			</div>
			<div class="d-flex position-absolute flex-row w-100 h-auto justify-center align-items-center flex-wrap mt-3 ml-3">
				<div class="d-flex justify-content-center flex-column">
					<button class="btn-transparent text-color-rhapsody-in-blue" v-b-tooltip.hover.left.html="tooltipContentOvertime">
						<component :is="getLucideIcon(ICONS.INFO.name)" :color="ICONS.INFO.color" :size="16" />
					</button>
				</div>
				<div>
					<div>{{ getWorked }}</div>
					<div>{{ getSalary }}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
export default {
	name: 'CellInfo',
	mixins: [languageMessages, globalMixin],
	components: {},
	props: {
		keyCell: {
			type: String,
			required: false,
			default: ''
		},
		arrayTsDays: {
			type: Array,
			required: false,
			default: () => []
		},
		labelStatus: {
			type: String,
			required: false
		},
		getWorked: {
			type: String,
			required: false,
			default: ''
		},
		getSalary: {
			type: String,
			required: false,
			default: ''
		},
		labelStatusColor: {
			type: String,
			required: false
		},
		tooltipContentOvertime: {
			type: String || undefined,
			required: false,
			default: ''
		}
	},
	data: () => ({})
};
</script>
<style scoped>
.status-not-submitted {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #fcede9;
	border: 1px solid #ea4e2c;
	animation: pulse 1.5s infinite;
}
.status-not-submitted:after {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #ea4e2c;
	animation: sonar 1.5s infinite;
}
.status-info {
	width: 10px;
	height: 10px;
	border-radius: 2px;
	background-color: #e7f2ff;
	border: 1px solid #225cbd;
}
.status-pending {
	width: 10px;
	height: 10px;
	border-radius: 2px;
	background-color: #fbf5e5;
	border: 1px solid #cd9a16;
}
.status-validated {
	width: 10px;
	height: 10px;
	border-radius: 2px;
	background-color: #ecf6e8;
	border: 1px solid #3c7442;
}
.status-refused {
	width: 10px;
	height: 10px;
	border-radius: 2px;
	background-color: #ffb0b0;
	border: 1px solid #980000;
}
.status-sent {
	width: 10px;
	height: 10px;
	border-radius: 2px;
	background-color: #d5d6d7;
	border: 1px solid #687887;
}
</style>
